<template>
  <main class="query-container">
    <Row class="query-row">
      <Col :xs="24" :sm="8" class="text-center">
        <div class="label">System</div>
      </Col>
      <Col :xs="24" :sm="14" class="text-left">
        <Select v-model="system">
          <Option v-for="(item, index) in systemList" :value="item" :key="index">{{ item }}</Option>
        </Select>
      </Col>
    </Row>
    <Row class="query-row text-center">
      <Col :xs="24" :sm="8">
        <div class="label">Start Time</div>
      </Col>
      <Col :xs="24" :sm="14">
        <DatePicker v-model="logTimeStart" type="datetime" format="yyyy-MM-dd HH:mm"></DatePicker>
      </Col>
    </Row>
    <Row class="query-row text-center">
      <Col :xs="24" :sm="8">
        <div class="label">End Time</div>
      </Col>
      <Col :xs="24" :sm="14">
        <DatePicker v-model="logTimeEnd" type="datetime" format="yyyy-MM-dd HH:mm"></DatePicker>
      </Col>
    </Row>
    <Row class="query-row text-center">
      <Col :xs="24" :sm="8">
        <div class="label">Text</div>
      </Col>
      <Col :xs="24" :sm="14">
        <Input v-model="logText"></Input>
      </Col>
    </Row>
    <Row class="query-row text-center">
      <Col :xs="24" :sm="8">
        <div class="label">Level</div>
      </Col>
      <Col :xs="24" :sm="14" style="padding-top: 5px">
        <CheckboxGroup v-model="logLevel">
          <Checkbox label="ERROR">ERROR</Checkbox>
          <Checkbox label="WARN">WARN</Checkbox>
          <Checkbox label="INFO">INFO</Checkbox>
        </CheckboxGroup>
      </Col>
    </Row>
    <Divider />
    <Row class="query-row">
      <Col span="24">
        <Button type="info" @click="query">Query</Button>
        <Button type="warning" @click="reset">Reset</Button>
      </Col>
    </Row>
    <Table
      :height="tableHeight"
      :columns="columnList"
      :data="logList"
      class="responsive-table"
      ref="logTable"
      highlight-row
      @on-row-click="detail"
    ></Table>
    <Page
      v-show="totalSize > pageSize"
      :total="totalSize"
      :page-size="pageSize"
      style="margin-top: 15px; margin-bottom: 25px"
      @on-change="changePage"
    />

    <Modal v-model="openWindow" :footer-hide="true" :width="modalWidth" @on-cancel="closeWindow">
      <p slot="header">
        {{ windowObject.title1 }} <span style="margin-left: 10px">{{ windowObject.title2 }}</span>
      </p>
      <div class="modal-content">
        <pre>{{ windowObject.content }}</pre>
      </div>
    </Modal>
  </main>
</template>

<script>
export default {
  name: "Query",
  data() {
    return {
      systemList: [],
      system: null,
      logTimeStart: null,
      logTimeEnd: null,
      logText: null,
      logLevel: [],
      tableHeight: window.innerWidth <= 768 ? 300 : 450,
      modalWidth: window.innerWidth <= 768 ? 350 : 1000,
      columnList: [
        {
          title: "Time",
          key: "logTime",
          width: window.innerWidth <= 768 ? "120" : "170",
        },
        {
          title: "Level",
          key: "logLevel",
          width: window.innerWidth <= 768 ? "80" : "100",
        },
        {
          title: "Method",
          key: "logMethod",
          width: window.innerWidth <= 768 ? "150" : "250",
        },
        {
          title: "File",
          key: "logFile",
          width: window.innerWidth <= 768 ? "150" : "300",
        },
        {
          title: "Text",
          key: "logText",
          render: (h, params) => {
            let text = params.row.logText
            if (window.innerWidth <= 768) {
              return h("span", "")
            } else {
              return h("span", text && text.length > 80 ? text.substring(0, 80) : text)
            }
          },
        },
      ],
      logList: [],
      pageSize: parseInt(process.env.VUE_APP_LIST_SIZE),
      totalSize: 0,
      currentPage: 1,
      openWindow: false,
      windowObject: {},
    }
  },
  methods: {
    async query() {
      if (this.systemList.length == 0) {
        return
      }
      try {
        let body = {}
        body.system = this.system
        body.token = this.$store.getters.getToken(this.system)
        body.logTimeStart = this.logTimeStart
        body.logTimeEnd = this.logTimeEnd
        body.logLevel = JSON.parse(JSON.stringify(this.logLevel))
        body.logText = this.logText
        let response = await this.$http.post(`/getLog/${this.currentPage}`, body)
        this.logList = response.data.logList.length > 0 ? response.data.logList : []
        this.totalSize = response.data.totalSize
      } catch (error) {
        this.logList = []
        this.totalSize = 0
        this.$Message.error({
          background: true,
          content: `ERROR: ${error.toString()}`,
        })
      }
    },
    changePage(page) {
      this.currentPage = page
      this.query()
    },
    reset() {
      this.system = this.systemList[0]
      this.logTimeStart = null
      this.logTimeEnd = null
      this.logLevel = []
      this.logText = null
      this.logList = []
    },
    detail(payload) {
      this.openWindow = true
      this.windowObject.title1 = payload.logMethod
      this.windowObject.title2 = payload.logFile
      this.windowObject.content = payload.logText
    },
    closeWindow() {
      this.openWindow = false
      this.windowObject = {}
      this.$refs.logTable.clearCurrentRow()
    },
  },
  mounted() {
    setTimeout(() => {
      this.systemList = this.$store.getters.getSystemList()
      this.system = this.systemList[0]
    }, 500)
  },
  created() {
    this.$store.dispatch("init")
  },
}
</script>

<style scoped>
.query-container {
  padding: 10px;
}

.query-row {
  margin-bottom: 15px;
}

.full-width-input {
  width: 100% !important;
  max-width: 300px;
}

.responsive-table {
  margin-top: 20px;
  cursor: pointer;
  overflow-x: auto;
}

.modal-content {
  max-height: 70vh;
  overflow-y: auto;
}

.modal-content pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
  font-family: monospace;
}

@media screen and (max-width: 768px) {
  .text-right {
    text-align: left !important;
    margin-bottom: 5px;
  }

  .label {
    margin-bottom: 5px;
  }

  .query-row {
    margin-bottom: 20px;
  }

  .ivu-btn {
    margin: 5px;
  }
}
</style>
